import { useState } from "react";
import {
	FileWithShare,
} from "../../../../lib/supabase/supabaseTypes";
import { FocusedItem } from "./focused-item.component";
import { useJobStore } from "../../store/Job";

export type FileWithImage = FileWithShare & {
	image?: string;
};

export const FilesGallery = ({
	id,
	connectedOrganizationId,
}: {
	id: string | number;
	connectedOrganizationId?: string;
}) => {
	const { labFiles, medFiles, shareFile, unshareFile } =
		useJobStore();

	const [focusedFile, setFocusedFile] = useState<FileWithImage | null>(null);

	const shareButtonText = (file: FileWithImage) => {
		if (file.shared_ids && file.shared_ids[0]) {
			return file.shared_until ? "Erneut teilen" : "Entteilen";
		}
		return "Teilen";
	};

	const handleShareButtonClick = (file: FileWithImage) => {
		if (!file.id) return;
		if (!file.job_id) return;

		if (file.shared_ids && file.shared_ids[0]) {
			if (file.shared_until && new Date(file.shared_until) < new Date()) {
				shareFile(file.id, file.job_id);
			} else {
				unshareFile(file.id, file.job_id);
			}
		} else {
			shareFile(file.id, file.job_id);
		}
	};

	if (
		!id ||
		(labFiles.length == 0 &&
			medFiles.length == 0)
	) {
		return <div className="text-center my-4">Keine Dateien vorhanden</div>;
	}

	return (
		<div className="mt-2">
			<div className=" overflow-y-auto">
				<>
        {(labFiles.length > 0 || medFiles.length > 0) && (
  <>
          {labFiles.length > 0 && (
            <div className="font-bold">
              Eigene:
            </div>
          )}
          {labFiles.map(
            (file, index) =>
              file.meta_data && (
                <div className="flex flex-col my-2">
                  <div
                    key={file.id}
                    onClick={() => {
                      open(
                        // @ts-expect-error image doesn't exist in data
                        file.image,
                        "_blank"
                      );
                    }}
                    className="flex items-center justify-between p-3 transition-colors active:bg-gray-100 border border-blue-200 rounded-md"
                  >
                    <div className="flex items-center gap-2">
                      <span className="text-sm text-gray-500 uppercase">
                        {typeof file.meta_data ===
                          "object" &&
                        "type" in
                          file.meta_data
                          ? (
                              file.meta_data as {
                                type: string;
                              }
                            ).type
                          : ""}
                      </span>
                      <span className="font-medium">
                        {
                          file.file_name?.split(
                            "."
                          )[0]
                        }
                      </span>
                      {connectedOrganizationId && (
                        <label
                          className="text-blue-600 transition-colors active:text-blue-200 items-center flex"
                          onClick={(
                            e
                          ) => {
                            e.stopPropagation();
                            handleShareButtonClick(
                              file
                            );
                          }}
                        >
                          {shareButtonText(
                            file
                          )}
                        </label>
                      )}
                    </div>
                  </div>
                </div>
              )
          )}
          {medFiles.length > 0 && (
            <div className="font-bold mt-4">
              Von Auftraggeber:
            </div>
          )}
          {medFiles.map(
            (file, index) =>
              file.meta_data && (
                <div className="flex flex-col my-2">
                  <div
                    key={file.id}
                    onClick={() => {
                      open(
                        // @ts-expect-error image doesn't exist in data
                        file.image,
                        "_blank"
                      );
                    }}
                    className="items-center justify-between p-3 transition-colors active:bg-gray-100 border border-blue-200 rounded-md"
                  >
                    <div className="flex items-center gap-2">
                      <span className="text-sm text-gray-500 uppercase">
                        {typeof file.meta_data ===
                          "object" &&
                        "type" in
                          file.meta_data
                          ? (
                              file.meta_data as {
                                type: string;
                              }
                            ).type
                          : ""}
                      </span>
                      <span className="font-medium">
                        {
                          file.file_name?.split(
                            "."
                          )[0]
                        }
                      </span>
                    </div>
                  </div>
                </div>
              )
          )}
  </>
)}
				</>
				<FocusedItem
					file={focusedFile}
					onClose={() => setFocusedFile(null)}
					handleShareButtonClick={handleShareButtonClick}
					connectedOrganizationId={connectedOrganizationId}
					shareButtonText={shareButtonText}
				/>
			</div>
		</div>
	);
};